
import {useHead} from '@vueuse/head'
import RepoHistory from "./repohistory/RepoHistoryTemplate.vue"
import SidebarLayout from '../layouts/SidebarLayout.vue'
import {computed, defineComponent, reactive} from "vue";

import VButton from '../components/base/button/VButton.vue'
import {useToggle} from '@vueuse/core'
import {mapState} from "vuex";

export default defineComponent({
  name: 'Login',
  components: {
    VButton,
    RepoHistory,
    SidebarLayout
  },

  setup() {
    const siteData = reactive({
      title: `JB Drax Honoré Repo History`
    })
    useHead({
      title: computed(() => siteData.title),
    })
    useToggle(false)

  },
  computed: {
    ...mapState(['user'])
  },
})
